export default __webpack_public_path__ + "static/media/elecstorm.5460f848.gif";